function isVulnerableKey(key) {
    return key === '__proto__' || key === 'constructor';
}

function assignPath(obj, props, value) {
    var lastProp = props.pop();
    var thisProp = void 0;

    if (isVulnerableKey(lastProp)) return;

    while (thisProp = props.shift()) {
        if (isVulnerableKey(thisProp)) return;
        if (!obj[thisProp]) {
            obj[thisProp] = /^\d*$/.test(props[0] || lastProp) ? [] : {};
        }

        obj = obj[thisProp];
    }

    if (lastProp === '' && Array.isArray(obj)) {
        obj.push(value);
    } else {
        obj[lastProp] = value;
    }
}

function reduceKeyValues(data, keyValue) {
    var pair = keyValue.split('=').map(decodeURIComponent);
    var path = pair[0].replace(/\[(.*?)\]/g, '&$1').split('&');

    assignPath(data, path, pair[1]);

    return data;
}

function serialize(data) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var serialized = [];

    for (var key in data) {
        var value = data[key];

        //undefined or null
        if (value == void 0) {
            continue;
        }

        key = prefix ? prefix + ('[' + encodeURIComponent(key) + ']') : encodeURIComponent(key);

        if (typeof value === 'object') {
            var child = serialize(value, key);
            child && serialized.push(child);
        } else {
            serialized.push(key + '=' + encodeURIComponent(value));
        }
    }

    return serialized.join('&');
}

function deserialize(queryString) {
    return queryString.split('&').reduce(reduceKeyValues, {});
}

function join(url, querystring) {
    var qsStart = url.indexOf('?');
    var anchorStart = url.indexOf('#');
    var anchor = '';

    if (anchorStart !== -1) {
        anchor = url.substring(anchorStart);
        url = url.substring(0, anchorStart);
    }

    if (qsStart === -1) {
        url += '?';
    } else if (qsStart < url.length - 1) {
        url += '&';
    }

    return url + querystring + anchor;
}

function get(url) {
    var qsStart = url.indexOf('?');
    var anchorStart = url.indexOf('#');

    return ~qsStart ? ~anchorStart ? url.slice(qsStart + 1, anchorStart) : url.slice(qsStart + 1) : '';
}

export { serialize, deserialize, join, get };
